/**
 * @generated SignedSource<<d52a9f46039cf8003039958b88324ba1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceViewRendererQuery$variables = {
  id: string;
};
export type WorkspaceViewRendererQuery$data = {
  readonly node: {
    readonly renderer?: {
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRendererFragment">;
    } | null | undefined;
  };
};
export type WorkspaceViewRendererQuery = {
  response: WorkspaceViewRendererQuery$data;
  variables: WorkspaceViewRendererQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkspaceRunner",
    "kind": "LinkedField",
    "name": "renderer",
    "plural": false,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "WorkspaceRendererFragment"
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkspaceRunner",
    "kind": "LinkedField",
    "name": "renderer",
    "plural": false,
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phase",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceViewRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v2/*:: as any*/),
            "type": "Workspace",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v2/*:: as any*/),
            "type": "WorkspaceVersion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceViewRendererQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v4/*:: as any*/),
            "type": "Workspace",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v4/*:: as any*/),
            "type": "WorkspaceVersion",
            "abstractKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "981b391e7913f6b334bd962187f64b29",
    "id": null,
    "metadata": {},
    "name": "WorkspaceViewRendererQuery",
    "operationKind": "query",
    "text": "query WorkspaceViewRendererQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Workspace {\n      renderer {\n        ...WorkspaceRendererFragment\n        id\n      }\n    }\n    ... on WorkspaceVersion {\n      renderer {\n        ...WorkspaceRendererFragment\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment WorkspacePhaseProgressFragment on WorkspaceRunner {\n  phase\n}\n\nfragment WorkspaceRendererFragment on WorkspaceRunner {\n  id\n  phase\n  url\n  ...WorkspacePhaseProgressFragment\n}\n"
  }
};
})();

(node as any).hash = "d6ee474bee6a861d71b871e51a64f430";

export default node;
